// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1iI4W","paramInput":"JobSimulator_paramInput__2m1b9","input":"JobSimulator_input__1buxi"};